<template>
  <div class="xl:w-[1100px] pt-[80px] mx-auto">
    <h2 class="text-2xl text-left font-bold">ค้นหาขั้นสูง</h2>
    <AdvanceSearchForm></AdvanceSearchForm>
  </div>
</template>

<script>
import AdvanceSearchForm from '@/components/AdvanceSearchForm.vue';
export default {
  components: {
    AdvanceSearchForm,
  },
};
</script>
